<input
  type="text"
  readonly
  class="{{ classNames }}"
  placeholder="{{ placeholderText }}"
  id="{{ datePickerId }}"
  autocomplete="false"
  [value]="dateValue"
  (input)="dateInput()"
  (change)="dateSelected($event)"
/>
<!--"dateValue=($event.target.value)"-->
